export default "__VITE_ASSET__C_FZsg1A__"